<p-confirmDialog
[header]="'Confirmation'"
[draggable]="false"
[rejectLabel]="'Non'"
[acceptLabel]="'Oui'"
[rejectButtonStyleClass]="'bg-secondary btn btn-secondary text-white'"
[acceptButtonStyleClass]="'ms-3'"
[style]="{'min-width':'350px'}"
>

  <ng-template pTemplate="message" let-message>
    <div class="mt-2">
      {{message.message}}
    </div>
  </ng-template>

</p-confirmDialog>
